/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import useGlobalFields from './useGlobalFields'

export default function useResetPasswordFields({form, prefix = ''}) {
    const {email} = useGlobalFields({
        form,
        prefix
    })

    const fields = {
        email
    }

    return fields
}
